// import logo from './logo.svg';
import './App.css';
import { Routes, Route, HashRouter } from 'react-router-dom';
import Home from './pages/home/home';
import UserInfo from './pages/userInfo/userInfo';
import Assessment from './pages/assessment/assessment';
import AssessmentResults from './pages/assessmentResults/assessmentResults';
import NoPage from './pages/nopage/nopage';
import Settings from './pages/settings/settings';
import Sandbox from './pages/sandbox/sandbox';
import ScrollToTop from './components/scrollToTop/scrollToTop';
import Admin from './pages/admin/admin';
import Gradebook from './pages/gradebook/gradebook';
import AdminAssessment from './pages/adminAssessment/adminAssessment';
import Dashboard from './pages/dashboard/dashboard';
import AdminAnalytics from './pages/adminAnalytics/adminAnalytics';
import RawDataExplorer from './pages/rawDataExplorer/rawDataExplorer';

function App() {
  return (
    <HashRouter basename='/'>
      <ScrollToTop></ScrollToTop>
      <Routes>
        <Route path="/" element={<Assessment></Assessment>}></Route>
        <Route path='/user-info' element={<UserInfo></UserInfo>}></Route>
        <Route path="/assessment/:category" element={<Assessment></Assessment>}></Route>
        <Route path="/assessment-results/" element={<AssessmentResults></AssessmentResults>}></Route>
        <Route path='/settings' element={<Settings></Settings>}></Route>
        <Route path="*" element={<NoPage></NoPage>}></Route>
        <Route path='/sand' element={<Sandbox></Sandbox>}></Route>
        <Route path='/admin' element={<Admin></Admin>}></Route>
        <Route path='/admin/gradebook' element={<Gradebook></Gradebook>}></Route>
        <Route path='/admin/gradebook/assessment/:id' element={<AdminAssessment></AdminAssessment>}></Route>
        <Route path='/admin/dashboard' element={<Dashboard></Dashboard>}></Route>
        <Route path='/admin/analytics' element={<AdminAnalytics></AdminAnalytics>}></Route>
        <Route path='admin/analytics/rde' element={<RawDataExplorer></RawDataExplorer>}></Route>
      </Routes>
      
    </HashRouter>
  );  
}

export default App;
